import { createTheme, type Theme } from "@mui/material/styles";

export const pink = {
  fonts: {
    mainFont: "Avenir Next, sans-serif",
    subFont: "Hira Kaku Pro N, sans-serif",
    textFont: "Hiragino Sans",
    numberFont: "Avenir Next, sans-serif",
  },
  colors: {
    mainColor: "#DC5F0D",
    subTextColor: "#8E354A",
    lineColor: "#E6E5E4",
    backgroundColor: "#F8C3CD",
    titleBackgroudColor: "#F8F4F4",
    accentColor: "#EB7A77",
    stageColor: "#CB1B45",
  },
  fontSize: {
    title: "18px",
    subTitle: "16px",
    p: "14px",
  },
};

export interface CustomTheme extends Theme {
  customPalette: {
    background: {
      gray: string;
      lightGray: string;
    };
    border: string;
    border2: string;
    activeBorder: string;
    hover: string;
    typography: {
      link: string;
    };
  };
}

const baseTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#1C1C1C",
    },
    secondary: {
      main: "#F7F7F7",
      dark: "#303030",
      light: "#bdbdbd",
    },
    background: {
      default: "#F1F1F1",
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
    },
  },
  typography: {
    fontFamily:
      "ui-sans-serif, system-ui, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol, Noto Color Emoji",
    body1: {
      fontSize: "0.75rem", // 16px * 0.75 = 12px
    },
    subtitle1: {
      fontSize: "0.875rem", // 16px * 0.875 ≈ 14px
    },
    subtitle2: {
      fontSize: "1rem", // 16px * 1 ≈ 16px
    },
    caption: {
      fontSize: "0.625rem", // 16px * 0.625 = 10px
    },
  },
  shape: {
    borderRadius: 4,
  },
});

// カスタムプロパティを追加
export const theme: CustomTheme = {
  ...baseTheme,
  customPalette: {
    border: "#EAEAEB",
    border2: "#636B7E",
    activeBorder: "#D66D30",
    hover: "#e8e8e8",
    background: {
      gray: "#ddd",
      lightGray: "#F7F7F7",
    },
    typography: {
      link: "#00B2FF",
    },
  },
};
